/* =========================================================
   RoyalArt — product.js  (PDP)
   Variant selection · gallery · pincode · sticky bar · recently viewed
   ========================================================= */
(function () {
  "use strict";
  var RA = (window.RoyalArt = window.RoyalArt || {});
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(c) { return RA.formatMoney ? RA.formatMoney(c) : "₹" + (c / 100).toFixed(0); }

  var form = $("[data-product-form]");
  var dataEl = $("[data-product-variants]");
  if (!form || !dataEl) { initGallery(); initRecentlyViewed(); initShare(); initFloatVideo(); return; }

  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

  /* ---------- Variant selection ---------- */
  function selection() {
    var sel = {};
    $all("[data-option-input]:checked", form).forEach(function (i) { sel[i.dataset.optionPos] = i.value; });
    return sel;
  }
  function findVariant(sel) {
    // A product with only its default variant renders no option inputs at all, so there
    // is nothing to match against - it IS the variant. (Without this every single-variant
    // product read "Unavailable".)
    if (!$all("[data-option-input]", form).length) return variants[0];
    return variants.find(function (v) {
      return v.options.every(function (val, idx) { return sel[idx + 1] === val; });
    });
  }
  function variantForValue(pos, value) {
    var sel = selection();
    sel[pos] = value;
    // Relaxed match: ignore option axes not yet chosen, so e.g. size buttons
    // stay browsable/priced when the frame is deselected. When every axis is
    // chosen this collapses to an exact match.
    return variants.find(function (v) {
      return v.options.every(function (val, idx) {
        return sel[idx + 1] === undefined || sel[idx + 1] === val;
      });
    });
  }

  /* ---------- Size hint: how big it really is, and what the next size up costs ---------- */
  var SIZE_USES = [   // [longest side up to, inches] -> same room labels as /pages/size-guide
    [12, "a desk or shelf"], [18, "a gallery wall"], [24, "a bedside or study"], [30, "a console or hallway"],
    [36, "above a sofa or bed"], [40, "a living room"], [48, "a statement wall"], [Infinity, "an oversized feature wall"]
  ];
  function parseDims(value) {
    var m = /^(\d+)\s*[x×]\s*(\d+)$/.exec(String(value).trim());
    return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : null;
  }
  function sizeLabel(value) {
    var d = parseDims(value);
    return d ? d[0] + " × " + d[1] + "″" : value;
  }
  function wholeRupees(c) { return money(c).replace(/\.00$/, "").replace(/^Rs\.\s*/, "Rs "); }
  function sizeHint(v) {
    var box = $("[data-size-hint]");
    if (!box) return;
    var group = box.closest("[data-option-group]");
    var inputs = $all("[data-option-input]", group);
    var at = -1;
    inputs.forEach(function (input, i) { if (input.checked) at = i; });
    if (at < 0) { box.hidden = true; return; }

    var use = $("[data-size-hint-use]", box);
    var d = parseDims(inputs[at].value);
    if (d) {
      var longest = Math.max(d[0], d[1]);
      var fit = SIZE_USES.filter(function (u) { return longest <= u[0]; })[0][1];
      use.textContent = "About " + Math.round(d[0] * 2.54) + " × " + Math.round(d[1] * 2.54) + " cm. Good for " + fit + ".";
    } else {
      use.textContent = "";
    }

    var up = $("[data-size-hint-up]", box);
    var next = inputs[at + 1];
    var nv = null;
    if (next && v) {
      var sel = selection();
      sel[next.dataset.optionPos] = next.value;
      nv = findVariant(sel);
    }
    if (nv && nv.available && nv.price > v.price) {
      up.textContent = "Go bigger: " + sizeLabel(next.value) + " for just +" + wholeRupees(nv.price - v.price);
      up.onclick = function () {
        next.checked = true;
        next.dispatchEvent(new Event("change", { bubbles: true }));
      };
      up.hidden = false;
    } else {
      up.onclick = null;
      up.hidden = true;
    }
    box.hidden = false;
  }

  function update() {
    var v = findVariant(selection());
    sizeHint(v);
    var priceEl = $("[data-price]"), cmpEl = $("[data-compare]"), offEl = $("[data-off]");
    var addBtn = $("[data-add-btn]"), addLabel = $("[data-add-label]"), idInput = $("[data-variant-id]");
    var stickyAdd = $("[data-sticky-add]"), stickyPrice = $("[data-sticky-price]");
    var stockEl = $("[data-stock]"), buyNow = $("[data-buy-now]");

    // current option labels
    $all("[data-option-group]").forEach(function (g) {
      var checked = $("[data-option-input]:checked", g);
      var lbl = $("[data-option-current]", g);
      if (checked && lbl) lbl.textContent = checked.value;
    });

    // availability + size prices for every option value
    $all("[data-option-input]", form).forEach(function (input) {
      var rep = variantForValue(input.dataset.optionPos, input.value);
      input.disabled = input.checked ? false : (!rep || !rep.available);
      if (input.dataset.optionPos && rep) {
        var label = form.querySelector('label[for="' + input.id + '"]');
        var sp = label && label.querySelector("[data-size-price]");
        if (sp) sp.textContent = money(rep.price);
      }
    });

    if (!v) {
      // Distinguish "nothing picked yet on an axis" from a truly missing combo.
      var incomplete = Object.keys(selection()).length < $all("[data-option-group]").length;
      if (addBtn) { addBtn.disabled = true; }
      if (buyNow) buyNow.disabled = true;
      if (stickyAdd) stickyAdd.disabled = true;
      if (addLabel) addLabel.textContent = incomplete ? "Select a frame" : "Unavailable";
      if (stockEl) stockEl.textContent = incomplete ? "Choose a frame to continue" : "This combination is unavailable";
      return;
    }

    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    if (cmpEl && offEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false;
        offEl.textContent = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + "% off"; offEl.hidden = false;
      } else { cmpEl.hidden = true; offEl.hidden = true; }
    }
    var avail = v.available;
    [addBtn, stickyAdd, buyNow].forEach(function (b) { if (b) b.disabled = !avail; });
    if (addLabel) addLabel.textContent = avail ? "Add to cart" : "Sold out";
    if (stockEl) stockEl.textContent = avail ? "In stock · ready to ship" : "Currently unavailable";

    // gallery swap to variant image
    if (v.featured_image && v.featured_image.id) setActiveMedia(v.featured_image.id);

    // url
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  form.addEventListener("change", function (e) {
    if (e.target.matches("[data-option-input]")) update();
  });

  /* ---------- Quantity ---------- */
  var qtyInput = $("[data-pdp-qty]", form);
  $all("[data-qty-up],[data-qty-down]", form).forEach(function (btn) {
    btn.addEventListener("click", function () {
      var q = parseInt(qtyInput.value, 10) || 1;
      q = btn.hasAttribute("data-qty-up") ? q + 1 : Math.max(1, q - 1);
      qtyInput.value = q;
    });
  });

  /* ---------- Buy now ---------- */
  var buyNow = $("[data-buy-now]");
  if (buyNow) {
    buyNow.addEventListener("click", function () {
      buyNow.classList.add("is-loading");
      fetch(RA.routes.cart_add || "/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function () { buyNow.classList.remove("is-loading"); });
    });
  }

  /* ---------- Sticky bar add ---------- */
  var stickyAdd = $("[data-sticky-add]");
  if (stickyAdd) stickyAdd.addEventListener("click", function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });

  /* ---------- Pincode ---------- */
  var pinBtn = $("[data-pincode-check]"), pinInput = $("[data-pincode-input]"), pinMsg = $("[data-pincode-msg]");
  if (pinBtn) {
    pinBtn.addEventListener("click", function () {
      var pin = (pinInput.value || "").trim();
      if (!/^\d{6}$/.test(pin)) { pinMsg.className = "pincode__msg is-err"; pinMsg.textContent = "Enter a valid 6-digit pincode."; return; }
      var days = 3 + (parseInt(pin[5], 10) % 4); // 3–6
      pinMsg.className = "pincode__msg is-ok";
      pinMsg.innerHTML = "Delivers to <b>" + pin + "</b> in " + days + "–" + (days + 2) + " business days · Free shipping · COD available";
    });
  }

  /* ---------- init shared ---------- */
  update();
  initGallery();
  initRecentlyViewed();
  initShare();
  initFloatVideo();

  /* ---------- Share ---------- */
  function initShare() {
    var wrap = $("[data-share]");
    if (!wrap) return;
    var url = wrap.dataset.shareUrl || window.location.href;
    var title = wrap.dataset.shareTitle || document.title;
    var toast = $("[data-share-toast]", wrap);
    var toastTimer;

    /* open / close sheet */
    var sheet = $("[data-share-sheet]", wrap);
    var trigger = $("[data-share-open]", wrap);
    function openSheet() {
      if (!sheet) return;
      sheet.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { sheet.classList.add("is-open"); });
      if (trigger) trigger.setAttribute("aria-expanded", "true");
      document.addEventListener("keydown", onKey);
    }
    function closeSheet() {
      if (!sheet) return;
      sheet.classList.remove("is-open");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      document.removeEventListener("keydown", onKey);
      setTimeout(function () { sheet.hidden = true; }, 320);
    }
    function onKey(e) { if (e.key === "Escape") closeSheet(); }
    if (trigger) trigger.addEventListener("click", openSheet);
    $all("[data-share-close]", wrap).forEach(function (el) { el.addEventListener("click", closeSheet); });

    function flash(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add("is-on");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove("is-on"); }, 2200);
    }

    function copyLink() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(url);
      }
      return new Promise(function (resolve, reject) {
        try {
          var t = document.createElement("textarea");
          t.value = url; t.setAttribute("readonly", ""); t.style.position = "absolute"; t.style.left = "-9999px";
          document.body.appendChild(t); t.select();
          document.execCommand("copy"); document.body.removeChild(t);
          resolve();
        } catch (e) { reject(e); }
      });
    }

    var copyBtn = $("[data-share-copy]", wrap);
    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        copyLink().then(function () { flash("Link copied"); }, function () { flash("Press Ctrl+C to copy"); });
      });
    }

    // Instagram can't prefill — copy the link so the customer can paste it in a DM/story.
    var igBtn = $("[data-share-ig]", wrap);
    if (igBtn) {
      igBtn.addEventListener("click", function () {
        copyLink().then(function () { flash("Link copied — paste it in Instagram"); }, function () {});
      });
    }

    // Native share sheet (mobile) — reveal when supported.
    var nativeBtn = $("[data-share-native]", wrap);
    if (nativeBtn && navigator.share) {
      nativeBtn.hidden = false;
      nativeBtn.addEventListener("click", function () {
        navigator.share({ title: title, url: url }).catch(function () {});
      });
    }
  }

  /* ---------- Floating draggable video ---------- */
  function initFloatVideo() {
    var box = $("[data-float-video]");
    if (!box) return;
    var key = "ra_fv_dismissed_" + (box.dataset.floatKey || "");
    try { if (sessionStorage.getItem(key)) { box.remove(); return; } } catch (e) {}

    box.hidden = false;
    var video = $("[data-float-player]", box);
    if (video) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }

    /* close */
    var closeBtn = $("[data-float-close]", box);
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        if (video) { try { video.pause(); } catch (e) {} }
        box.remove();
        try { sessionStorage.setItem(key, "1"); } catch (e) {}
      });
    }

    /* sound toggle */
    var soundBtn = $("[data-float-sound]", box);
    if (soundBtn && video) {
      soundBtn.addEventListener("click", function () {
        video.muted = !video.muted;
        if (!video.muted) { var pp = video.play(); if (pp && pp.catch) pp.catch(function () {}); }
        var off = $("[data-float-sound-off]", soundBtn), on = $("[data-float-sound-on]", soundBtn);
        if (off) off.hidden = !video.muted;
        if (on) on.hidden = video.muted;
      });
    }

    /* drag */
    var handle = $("[data-float-handle]", box) || box;
    var dragging = false, moved = false, startX = 0, startY = 0, baseLeft = 0, baseTop = 0;
    var pad = 10;

    function onDown(e) {
      if (e.target.closest("[data-float-close]") || e.target.closest("[data-float-sound]")) return;
      dragging = true; moved = false;
      var rect = box.getBoundingClientRect();
      // switch to top/left positioning anchored where it currently sits
      box.style.right = "auto"; box.style.bottom = "auto";
      box.style.left = rect.left + "px"; box.style.top = rect.top + "px";
      baseLeft = rect.left; baseTop = rect.top;
      startX = e.clientX; startY = e.clientY;
      box.classList.add("is-dragging");
      try { handle.setPointerCapture(e.pointerId); } catch (er) {}
    }
    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) moved = true;
      var w = box.offsetWidth, h = box.offsetHeight;
      var left = Math.min(Math.max(baseLeft + dx, pad), window.innerWidth - w - pad);
      var top = Math.min(Math.max(baseTop + dy, pad), window.innerHeight - h - pad);
      box.style.left = left + "px"; box.style.top = top + "px";
    }
    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      box.classList.remove("is-dragging");
      try { handle.releasePointerCapture(e.pointerId); } catch (er) {}
    }
    handle.addEventListener("pointerdown", onDown);
    handle.addEventListener("pointermove", onMove);
    handle.addEventListener("pointerup", onUp);
    handle.addEventListener("pointercancel", onUp);

    /* keep on-screen if window resizes */
    window.addEventListener("resize", function () {
      if (box.style.left === "" || box.style.left === "auto") return;
      var w = box.offsetWidth, h = box.offsetHeight;
      var left = Math.min(parseFloat(box.style.left) || 0, window.innerWidth - w - pad);
      var top = Math.min(parseFloat(box.style.top) || 0, window.innerHeight - h - pad);
      box.style.left = Math.max(left, pad) + "px"; box.style.top = Math.max(top, pad) + "px";
    });
  }

  /* ---------- Gallery ---------- */
  function setActiveMedia(id) {
    id = String(id);
    var slides = $all("[data-slide]");
    var matched = false;
    slides.forEach(function (s) {
      var on = String(s.dataset.mediaId) === id;
      s.classList.toggle("is-active", on);
      s.classList.remove("is-zoomed");
      if (!on) { var vid = s.querySelector("video"); if (vid) { try { vid.pause(); } catch (e) {} } }
      if (on) matched = true;
    });
    if (!matched) return;
    $all("[data-thumb]").forEach(function (t) {
      var on = String(t.dataset.mediaId) === id;
      t.classList.toggle("is-active", on);
      t.setAttribute("aria-current", on ? "true" : "false");
    });
  }
  function initGallery() {
    $all("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () { setActiveMedia(t.dataset.mediaId); });
    });

    // prev / next arrow navigation
    function step(dir) {
      var slides = $all("[data-slide]");
      if (slides.length < 2) return;
      var idx = slides.findIndex(function (s) { return s.classList.contains("is-active"); });
      if (idx < 0) idx = 0;
      var n = (idx + dir + slides.length) % slides.length;
      setActiveMedia(slides[n].dataset.mediaId);
      var thumb = $all("[data-thumb]")[n];
      if (thumb && thumb.scrollIntoView) thumb.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
    }
    var prevBtn = $("[data-gallery-prev]"), nextBtn = $("[data-gallery-next]");
    if (prevBtn) prevBtn.addEventListener("click", function (e) { e.stopPropagation(); step(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function (e) { e.stopPropagation(); step(1); });

    var main = $("[data-gallery-main]");
    if (main) {
      main.addEventListener("click", function (e) {
        var slide = e.target.closest(".gallery__slide");
        if (!slide || slide.dataset.mediaType !== "image") return; // zoom images only
        slide.classList.toggle("is-zoomed");
        if (slide.classList.contains("is-zoomed")) {
          var rect = slide.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          var img = slide.querySelector("img");
          if (img) img.style.transformOrigin = x + "% " + y + "%";
        }
      });
    }
  }

  /* ---------- Recently viewed ---------- */
  function initRecentlyViewed() {
    var KEY = "ra_recent";
    var handleEl = $("[data-product-handle]");
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}

    if (handleEl) {
      var handle = JSON.parse(handleEl.textContent);
      var img = $("[data-gallery-img]");
      var current = {
        handle: handle,
        title: ($(".pdp-title") || {}).textContent || handle,
        url: window.location.pathname,
        image: img ? img.src : "",
        price: ($("[data-price]") || {}).textContent || ""
      };
      list = list.filter(function (p) { return p.handle !== handle; });
      list.unshift(current);
      list = list.slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var rail = $("[data-recently-viewed-rail]");
    var section = $("[data-recently-viewed]");
    if (!rail || !section) return;
    var others = list.filter(function (p) { return p.url !== window.location.pathname; }).slice(0, 4);
    if (!others.length) return;
    rail.innerHTML = others.map(function (p) {
      return '<a href="' + p.url + '" class="card">' +
        '<div class="card__media">' + (p.image ? '<img src="' + p.image + '" alt="" width="600" height="750" loading="lazy">' : "") + "</div>" +
        '<div class="card__body"><h3 class="card__title">' + p.title + '</h3><div class="card__price">' + p.price + "</div></div></a>";
    }).join("");
    section.hidden = false;
  }
})();

/* =========================================================
   Frame Type -> Colour cascade (progressive enhancement)
   The Frame option ships as one select of "Type · Colour" values
   (e.g. "Moulding · Black"); "Wooden" has no colour. This splits it
   into a Type picker + a dependent Colour picker, driving the real
   (hidden) radios so the existing variant logic keeps working. If this
   never runs, the original 14-chip picker stays fully usable.
   ========================================================= */
(function () {
  "use strict";
  var SEP = " · ";
  var TYPE_ORDER = ["Moulding", "Floating", "Wooden"];
  var COLOUR_ORDER = ["Black", "White", "Brown", "Dark Wood", "Golden", "Light Wood", "Cream"];
  var SWATCH = {
    "Black": "#1a1a1a", "White": "#f4f2ec", "Brown": "#6b4a2b", "Dark Wood": "#4a3524",
    "Golden": "#c9a24a", "Light Wood": "#c9a978", "Cream": "#e9e0cf"
  };
  var NONE = " ";

  var src = document.querySelector("[data-cascade-frame]");
  if (!src) return;
  var radios = Array.prototype.slice.call(src.querySelectorAll("[data-option-input]"));
  if (!radios.length) return;

  function parse(val) {
    var i = val.indexOf(SEP);
    return i === -1 ? { type: val, colour: null } : { type: val.slice(0, i), colour: val.slice(i + SEP.length) };
  }
  function ordered(keys, order) {
    var out = order.filter(function (k) { return keys.indexOf(k) !== -1; });
    keys.forEach(function (k) { if (out.indexOf(k) === -1) out.push(k); });
    return out;
  }

  var byType = {}; // type -> { colour|NONE -> radio }
  radios.forEach(function (r) {
    var p = parse(r.value);
    (byType[p.type] = byType[p.type] || {})[p.colour === null ? NONE : p.colour] = r;
  });
  var types = ordered(Object.keys(byType), TYPE_ORDER);

  var wrap = document.createElement("div");
  wrap.className = "opt-cascade";
  var typeGroup = document.createElement("div");
  typeGroup.className = "opt-group opt-cascade__group";
  typeGroup.innerHTML = '<div class="opt-group__label"><span>Frame</span><b data-cascade-type-current></b></div>';
  var typeBtns = document.createElement("div");
  typeBtns.className = "opt-btns";
  typeGroup.appendChild(typeBtns);
  var colGroup = document.createElement("div");
  colGroup.className = "opt-group opt-cascade__group";
  colGroup.innerHTML = '<div class="opt-group__label"><span>Colour</span><b data-cascade-colour-current></b></div>';
  var colBtns = document.createElement("div");
  colBtns.className = "opt-btns";
  colGroup.appendChild(colBtns);
  wrap.appendChild(typeGroup);
  wrap.appendChild(colGroup);
  src.parentNode.insertBefore(wrap, src);
  src.style.display = "none"; // hide raw picker only now that the cascade exists

  var typeCurrent = typeGroup.querySelector("[data-cascade-type-current]");
  var colourCurrent = colGroup.querySelector("[data-cascade-colour-current]");
  var state = { type: null, colour: null };

  function selectRadio(type, colour) {
    var map = byType[type]; if (!map) return;
    var r = map[colour === null ? NONE : colour]; if (!r) return;
    if (!r.checked) { r.checked = true; r.dispatchEvent(new Event("change", { bubbles: true })); }
  }
  function uncheckFrame() {
    var r = src.querySelector("[data-option-input]:checked");
    if (r) { r.checked = false; r.dispatchEvent(new Event("change", { bubbles: true })); }
  }
  function clearType() {
    state.type = null; state.colour = null;
    typeCurrent.textContent = "";
    Array.prototype.forEach.call(typeBtns.children, function (x) { x.classList.remove("opt-chip--on"); });
    colGroup.style.display = "none";
    colBtns.innerHTML = "";
    colourCurrent.textContent = "";
    uncheckFrame();
  }
  function clearColour() {
    state.colour = null;
    colourCurrent.textContent = "";
    Array.prototype.forEach.call(colBtns.children, function (x) { x.classList.remove("opt-chip--on"); });
    uncheckFrame();
  }
  function colourKeys(type) {
    return Object.keys(byType[type]).filter(function (k) { return k !== NONE; });
  }
  function renderColours() {
    colBtns.innerHTML = "";
    var cols = ordered(colourKeys(state.type), COLOUR_ORDER);
    if (!cols.length) { // e.g. Wooden — no colour choice
      colGroup.style.display = "none";
      state.colour = null; colourCurrent.textContent = "";
      selectRadio(state.type, null); return;
    }
    colGroup.style.display = "";
    if (cols.indexOf(state.colour) === -1) state.colour = cols[0];
    cols.forEach(function (c) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "opt-chip opt-chip--colour" + (c === state.colour ? " opt-chip--on" : "");
      b.innerHTML = (SWATCH[c] ? '<span class="opt-swatch" style="background:' + SWATCH[c] + '"></span>' : "") + "<span>" + c + "</span>";
      b.addEventListener("click", function () {
        if (state.colour === c) { clearColour(); return; }
        state.colour = c; colourCurrent.textContent = c;
        Array.prototype.forEach.call(colBtns.children, function (x) { x.classList.remove("opt-chip--on"); });
        b.classList.add("opt-chip--on");
        selectRadio(state.type, c);
      });
      colBtns.appendChild(b);
    });
    colourCurrent.textContent = state.colour;
    selectRadio(state.type, state.colour);
  }
  function setType(type) {
    state.type = type; typeCurrent.textContent = type;
    Array.prototype.forEach.call(typeBtns.children, function (x) {
      x.classList.toggle("opt-chip--on", x.getAttribute("data-type") === type);
    });
    renderColours();
  }

  types.forEach(function (t) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "opt-chip"; b.setAttribute("data-type", t); b.textContent = t;
    b.addEventListener("click", function () { if (state.type === t) clearType(); else setType(t); });
    typeBtns.appendChild(b);
  });

  var checked = src.querySelector("[data-option-input]:checked") || radios[0];
  var init = parse(checked.value);
  state.colour = init.colour;
  setType(init.type);
})();
